import { Typography } from '@material-ui/core';
import { InfoCard, Stack, useUID } from '@superdispatch/ui';
import { ReactNode } from 'react';

interface ShipperProfileCardProps {
  title: ReactNode;
  children: ReactNode;
}

export function ShipperProfileCard({
  title,
  children,
}: ShipperProfileCardProps) {
  const uid = useUID();

  return (
    <InfoCard size="large">
      <Stack space="small">
        <Typography variant="h3" id={uid}>
          {title}
        </Typography>

        <div aria-labelledby={uid}>{children}</div>
      </Stack>
    </InfoCard>
  );
}
